var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 37,
    viewBox: "0 0 151 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_28577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7116 8.06031C24.2828 6.49135 22.8254 3.81893 22.8168 0.948242H16.6752L16.6665 25.4138C16.5538 28.2413 14.1596 30.4482 11.3143 30.3448C8.46909 30.2413 6.24841 27.8448 6.35251 25.0172C6.4566 22.2586 8.738 20.0862 11.5139 20.0862C12.0343 20.0862 12.5461 20.1638 13.0406 20.3276V14.0948C12.5374 14.0258 12.0257 13.9913 11.5139 13.9827C5.28554 13.9827 0.210938 19.0258 0.210938 25.2155C0.210938 31.4224 5.26819 36.4482 11.5139 36.4482C17.7595 36.4482 22.8168 31.4224 22.8168 25.2155V12.8103C25.3064 14.5862 28.2991 15.5431 31.3612 15.5431V9.43962C29.713 9.43962 28.0996 8.96548 26.7116 8.06031Z",
    fill: "#778092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2344 9.47412H56.5959L54.8177 14.9741H49.7864V35.3362H43.5321V14.9741L37.2344 14.9827V9.47412Z",
    fill: "#778092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3281 9.47412H108.141L106.362 14.9741H100.898V35.3362H94.6258V14.9741L88.3281 14.9827V9.47412Z",
    fill: "#778092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7852 17.6982H63.9874V35.3362H57.8199L57.7852 17.6982Z",
    fill: "#778092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4492 9.39648H72.6515V21.4396L78.8018 15.4482H86.2011L78.4288 22.9482L87.138 35.3361H80.3024L74.4905 26.7413L72.6515 28.5172V35.3275H66.4492V9.39648Z",
    fill: "#778092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.523 9.39648H135.726V21.4396L141.876 15.4482H149.284L141.512 22.9482L150.221 35.3361H143.385L137.573 26.7413L135.734 28.5172V35.3275H129.532V9.39648H129.523Z",
    fill: "#778092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8806 15.681C62.6053 15.681 64.0035 14.2916 64.0035 12.5776C64.0035 10.8636 62.6053 9.47412 60.8806 9.47412C59.156 9.47412 57.7578 10.8636 57.7578 12.5776C57.7578 14.2916 59.156 15.681 60.8806 15.681Z",
    fill: "#778092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.372 14.2153C110.508 14.2153 105.746 18.9395 105.746 24.7671C105.746 30.5946 110.5 35.3274 116.364 35.3274C122.228 35.3274 126.99 30.6033 126.99 24.7757C126.999 18.9481 122.245 14.224 116.372 14.2153ZM116.372 29.905C113.518 29.905 111.211 27.6119 111.211 24.7757C111.211 21.9395 113.518 19.6464 116.372 19.6464C119.226 19.6464 121.534 21.9395 121.534 24.7757C121.542 27.6119 119.226 29.905 116.372 29.905Z",
    fill: "#778092"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_28577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 35.5,
    fill: "white",
    transform: "translate(0.210938 0.948242)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTiktok);
export default __webpack_public_path__ + "static/media/icon-tiktok.e1dca829cfa9b2fa30696ae8083868ff.svg";
export { ForwardRef as ReactComponent };